import { GetQueueAIParams } from "../types/requestInputs";
import { GetQueueAIResponse } from "../types/requestsOutputs";
import { fetchAPI } from "./utils";

// Get QueueAI logs with pagination and filtering
export const getQueueAI = async ({
    token,
    page = 1,
    limit = 100,
    companyId,
}: GetQueueAIParams): Promise<GetQueueAIResponse> => {
    return fetchAPI<GetQueueAIResponse>("/get-queue-ai", "POST", { page, limit, companyId }, token);
};

// Get QueueAI files with pagination and filtering
export const getQueueAIFiles = async ({
    token,
    page = 1,
    limit = 100,
    companyId,
}: GetQueueAIParams): Promise<GetQueueAIResponse> => {
    return fetchAPI<GetQueueAIResponse>("/get-queue-ai-files", "POST", { page, limit, companyId }, token);
};
